import React from 'react';
import { Button, Col, Label, Row } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup } from 'availity-reactstrap-validation';
import AvField from '../../../shared/component/form/AvField';
import PropTypes from 'prop-types';
import Translate from "../../../shared/language/Translate";
import {
    APP_LOCAL_DATE_FORMAT,
    BILLING_APPROVAL_STATUS_ALL,
    BILLING_APPROVAL_STATUS_OK, convertDateTimeWithFormat,
    EXISTS,
    SERVICE_SUBCATEGORY,
    TENANT_ID
} from "../../../shared/utils/Constants";
import Dialog from "../../../shared/component/dialog/Dialog";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import LocationService from "../../../shared/service/LocationService";
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import TenantService from "../../../shared/service/TenantService";
import DateInput from "../../../shared/component/form/DateInput";
import { toast } from "react-toastify";

const data = {
    id: '',
    description: '',
    billingApproved: null
};
export default class CloseDialogSRConnect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pageMode: null,
            billingApprovalStatus: []
        }
        this.locationService = new LocationService();
        this.tenantService = new TenantService();
    }

    componentDidMount = () => {
        this.tenantService.getTenant().then(result => {
            if (result == TENANT_ID.GSB) {
                this.setState({ billingApprovalStatus: BILLING_APPROVAL_STATUS_OK });
            } else {
                this.setState({ billingApprovalStatus: BILLING_APPROVAL_STATUS_ALL });
            }
            this.setState({ tenantId: result });

        });
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Col md="8">
                    <Dialog
                        header={'Kapatma Bilgileri'} modal={true} resizable={true}
                        visible={this.state.displayDialog}
                        maximizable={true} responsive={true} onHide={() => {
                            this.setState({ displayDialog: false });
                        }}
                        style={{ width: '50vw' }}>

                        <AvForm onValidSubmit={this.closeSRConnect}>
                            <Toolbar display={true}>
                                <div className="p-toolbar-group-right">
                                    <Button color="primary" className="float-right" type="submit">
                                        Kaydet
                                    </Button>
                                    <Button color="primary" className="float-right"
                                        onClick={() => {
                                            this.setState({ displayDialog: false });
                                        }}>
                                        Vazgeç
                                    </Button>
                                </div>
                            </Toolbar>


                            <AvGroup>
                                <Label for="description">
                                    <Translate contentKey="description">Açıklama</Translate>
                                    <span style={{ color: 'red' }}> (*)</span>
                                </Label>
                                <AvField
                                    type="textarea"
                                    className="form-control textAreaHermes"
                                    name="description"
                                    validate={{
                                        maxLength: {
                                            value: 4000,
                                            errorMessage: "Bu alana en fazla 4000 karakter girebilirsiniz."
                                        },
                                        required: {
                                            value: "true",
                                            errorMessage: "Bu alanın doldurulması zorunludur."
                                        }
                                    }}
                                    value={this.state.data.description}
                                    onChange={this.__handleChange}
                                />
                                <AvFeedback>Bu alana en fazla 4000 karakter girebilirsiniz.</AvFeedback>
                            </AvGroup>
                            <AvGroup>
                                <Label for="billingApproved">
                                    Faturalama Onayı
                                    <span style={{ color: 'red' }}> (*)</span>
                                </Label>
                                <AvField type="select" className="form-control" name="billingApproved"
                                    value={this.state.data.billingApproved}
                                    disabled={true}
                                    onChange={this.__handleChange}>
                                    <option value="" />
                                    {this.state.billingApprovalStatus.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                            {this.state.data.billingApproved &&
                                <div className="position-relative form-group">
                                    <Label for="ratingDate">Faturalama Başlangıç Tarih</Label>
                                    <DateInput
                                        name="ratingDate"
                                        onChange={this.__handleChangeRatingDate}
                                        value={this.state.data.ratingDate} />
                                </div>}
                        </AvForm>
                    </Dialog>
                </Col>
            </Row>
        );
    }

    closeSRConnect = () => {
        this.props.closeSRConnect();
        this.setState({ displayDialog: false });
    }

    setData = (data) => {
        this.setState({ data: data, firstRatingDate: data.ratingDate });
    }


    clearData = () => {
        this.setState({ data: Object.assign({}, data) });
    }

    getData = () => {
        return this.state.data;
    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let data = this.state.data;
        data[e.target.name] = value;
        this.setState({ data: data });
    }

    __handleChangeRatingDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;

        let endDate = new Date(value).getTime();
        let currentDate = new Date().getTime();
        if (endDate > currentDate) {
            return toast.warn("Girdiğiniz tarih, bugünün tarihinden sonra olamaz!");
        }
        let startDate = new Date(this.state.firstRatingDate).getTime();
        if (startDate > endDate && convertDateTimeWithFormat(this.state.firstRatingDate, APP_LOCAL_DATE_FORMAT) !== convertDateTimeWithFormat(new Date(value), APP_LOCAL_DATE_FORMAT)) {
            return toast.warn("Girdiğiniz tarih, faturalama başlangıç tarihinden önce olamaz!");
        }
        if (convertDateTimeWithFormat(this.state.firstRatingDate, APP_LOCAL_DATE_FORMAT) === convertDateTimeWithFormat(new Date(value), APP_LOCAL_DATE_FORMAT)) {
            value = this.state.firstRatingDate;
        }
        let data = this.state.data;
        data[e.target.name] = value;
        this.setState({ data: data });
    }

    setDialog = (value) => {
        this.clearData();
        this.setState({ displayDialog: value });
    }

}

CloseDialogSRConnect.propTypes = {
    data: PropTypes.object
};
